export const recruiterJobConstants = {
  // create candidate
  GET_ALL_JOBS_RECRUITER_ACTION_REQUEST:
    "GET_ALL_JOBS_RECRUITER_ACTION_REQUEST",
  GET_ALL_JOBS_RECRUITER_ACTION_SUCCESS:
    "GET_ALL_JOBS_RECRUITER_ACTION_SUCCESS",
  GET_ALL_JOBS_RECRUITER_ACTION_FAILURE:
    "GET_ALL_JOBS_RECRUITER_ACTION_FAILURE",

  ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_REQUEST:
    "ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_REQUEST",
  ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_SUCCESS:
    "ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_SUCCESS",
  ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_FAILURE:
    "ASSIGN_CANDIDATE_TO_JOB_RECRUITER_ACTION_FAILURE",
};
